import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTutanotaComponent } from './simple-icons-tutanota.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTutanotaComponent ],
    exports:      [ SimpleIconsTutanotaComponent ],
    bootstrap:    []
})
export class SimpleIconsTutanotaModule {}
